import { useState } from 'react';
import { BlogPageSkeleton } from '../../components/BlogSkeleton/BlogPageSkeleton';
import css from './FractionalBlogPost.module.css';
import { deleteBlog } from '../../util/api';
import { Modal } from '../../components';

const FractionalBlogPost = props => {
  const { handleBlog, loading, visibleBlogs, isAdmin, onBlogsUpdate, onManageDisableScrolling } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const handleDeleteClick = (e, post) => {
    e.stopPropagation();
    setBlogToDelete(post);
    setShowDeleteModal(true);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setBlogToDelete(null);
  };

  const confirmDelete = async () => {
    if (!blogToDelete) return;
    setDeletingId(blogToDelete._id);
    try {
      await deleteBlog({ id: blogToDelete._id });
      if (onBlogsUpdate) {
        await onBlogsUpdate();
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
      alert("Failed to delete blog.");
    } finally {
      setDeletingId(null);
      setShowDeleteModal(false);
      setBlogToDelete(null);
    }
  };

  return (
    <>
      {loading ? (
        <BlogPageSkeleton count={10} />
      ) : (
        <div className={css.blog}>
          {visibleBlogs?.map((post, index) => (
            <article
              className={css.card}
              key={post._id || index}
              itemScope
              itemType="https://schema.org/BlogPosting"
              onClick={() => handleBlog(post)}
            >
              <div className={css.imageWrapper}>
                <img
                  src={post?.image}
                  alt={post?.title}
                  className={css.image}
                  itemProp="image"
                  loading="lazy"
                />
              </div>
              <meta itemProp="datePublished" content={post?.publishedAt} />
              <meta itemProp="dateModified" content={post?.updatedAt || post?.publishedAt} />
              <div itemProp="author" itemScope itemType="https://schema.org/Person">
                <meta itemProp="name" content="Raman" />
                <meta itemProp="jobTitle" content="Founder of Forteh" />
              </div>
              <h5 className={css.title} itemProp="headline">
                  {post?.title}
              </h5>
              {post?.description && (
                <meta itemProp="description" content={post.description} />
              )}
              {isAdmin && post?._id && (
                <div className={css.deleteCardBtnWrapper}>
                  <button
                    className={css.deleteCardBtn}
                    onClick={(e) => handleDeleteClick(e, post)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </article>
          ))}
        </div>

      )}

      <Modal
        id="BlogPage.deleteModal"
        isOpen={showDeleteModal}
        onClose={cancelDelete}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div className={css.modalContent}>
          <h3 className={css.modalTitle}>Delete Blog</h3>
          <p className={css.deleteMessage}>
            Are you sure you want to delete this blog?
            {blogToDelete?.title && (
              <strong className={css.deleteVideoTitle}> "{blogToDelete.title}"</strong>
            )}
          </p>
          <div className={css.modalActions}>
            <button
              className={css.deleteConfirmBtn}
              onClick={confirmDelete}
              disabled={deletingId === blogToDelete?._id}
            >
              {deletingId === blogToDelete?._id ? 'Deleting...' : 'Delete'}
            </button>
            <button
              className={css.cancelBtn}
              onClick={cancelDelete}
              disabled={deletingId === blogToDelete?._id}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FractionalBlogPost;
